import ShipsSupplay from "./marineServis/ShipsSuplly";
import ShipHusbandry from "./marineServis/ShipHusbandry";
import CivilWork from "./marineServis/CivilWokr";
import OffshoreWork from "./marineServis/OffshoreWork";
import supply from "../assets/marine (1).jpg"
import { Routes, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import sanga3 from "../assets/gedo (8).jpg"
import hus from "../assets/gedo (8).jpg"
import civil from "../assets/civil2.webp"
import shore from "../assets/work (24).jpg"
import Aos from 'aos';
import 'aos/dist/aos.css'
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

function CommercialServices() {

  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const { t } = useTranslation();

  useEffect(() => {
    Aos.init({ duration: 2000 });
  });
  <Routes>
    <Route path="./marineServis/ShipsSuplly" element={<ShipsSupplay />} />
    <Route path="./marineServis/ShipHusbandry" element={<ShipHusbandry />} />
    <Route path="./marineServis/CivilWork" element={<CivilWork />} />
    <Route path="./marineServis/OffshoreWork" element={<OffshoreWork />} />
  </Routes>

  return (
    <div className="p-4">
      <div className="w-full h-[50vh] md:h-[700px] relative" >
        <img src={sanga3} className="absolute inset-0 w-full h-full object-cover" />

        <div className='absolute inset-0 bg-black/40 flex items-center justify-center flex-row'>

          <div className=" flex items-center  flex-col rtl h-full p-4 m-6 justify-center">
            <h1 data-aos="fade-right" className="text-white text-3xl md:text-7xl font-normal md:font-bold">{t("main")}</h1>
            <h3 data-aos="fade-left" className="text-white text-base md:text-xl font-normal md:font-bold p-4">{t("marine")}</h3>
          </div>
        </div></div>


      <Link to={"./marineServis/ShipsSuplly"}>

        <div className="h-auto min-h-0 py-8 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">

          <div className='relative w-full md:w-[500px] h-64 md:h-[400px] '>
            <img src={supply} data-aos="fade-left" className="w-full h-full object-cover rounded border-blue-300 flex-shrink-0" />
            <div className="absolute inset-0 flex  flex-col justify-center ">
              <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-center'>
                <h2 className="text-white  text-xl md:text-xl font-normal md:font-bold p-2">15 years</h2>
              </div>
            </div>
          </div>

          <div data-aos="fade-right" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-0 md:ml-4 flex flex-col justify-center flex-1 h-auto md:h-[400px] overflow-visible md:overflow-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-4xl font-normal md:font-bold mb-2 text-gray-700">{t("supply")}</h2>
            <div className="text-gray-700 ">
              {t("sup")}
              <p className="font-normal md:font-bold">
                {t("sup2")}
              </p>
            </div>
            <div className='flex flex-col md:flex-row w-full p-4 justify-between text-blue-400 '>
              <h3 className=" font-normal md:font-bold mb-2 ">Provision Supply</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Deck and Engine Stores</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Safety Equipment </h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Fuel and Lubricants</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Custom Requests</h3>

            </div>
          </div>
          <div className="hidden md:block w-5 h-[300px]  ">
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
          </div>

        </div>

      </Link>

      <Link to={"./marineServis/ShipHusbandry"}>

        <div className="h-auto min-h-0 py-8 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">

          <div className='relative w-full md:w-[500px] h-64 md:h-[400px] '>
            <img src={hus} data-aos="fade-right" className="w-full h-full object-cover rounded border-blue-300 flex-shrink-0" />
            <div className="absolute inset-0 flex  flex-col justify-center ">
              <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-left'>
                <h2 className="text-white  text-xl md:text-xl font-normal md:font-bold p-2">15 years</h2>
              </div>
            </div>
          </div>

          <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-0 md:ml-4 flex flex-col justify-center flex-1 h-auto md:h-[400px] overflow-visible md:overflow-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-4xl font-normal md:font-bold mb-2 text-gray-700">{t("husbandry")}</h2>
            <div className="text-gray-700 ">
              {t("hus")}
              <p className="font-normal md:font-bold">{t("hus2")}
              </p></div>
            <div className='flex flex-col md:flex-row w-full p-4 justify-between text-blue-400'>
              <h3 className=" font-normal md:font-bold mb-2 ">Hull Cleaning</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Underwater Inspections</h3>
              <h3 className=" font-normal md:font-bold mb-2 "> Maintenance </h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Waste Disposal</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Bunker Coordination</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Crew Change Assistance</h3>
            </div>
          </div>
          <div className="hidden md:block w-5 h-[300px]  ">
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
          </div>

        </div>

      </Link>

      <Link to={"./marineServis/CivilWokr"}>

        <div className="h-auto min-h-0 py-8 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">
          <div className='relative w-full md:w-[500px] h-64 md:h-[400px] '>
            <img src={civil} data-aos="fade-left" className="w-full h-full object-cover rounded border-blue-300 flex-shrink-0" />
            <div className="absolute inset-0 flex  flex-col justify-center ">
              <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-center'>
                <h2 className="text-white  text-xl md:text-xl font-normal md:font-bold p-2">15 years</h2>
              </div>
            </div>

          </div>
          <div data-aos="fade-right" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-0 md:ml-4 flex flex-col justify-center flex-1 h-auto md:h-[400px] overflow-visible md:overflow-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-4xl font-normal md:font-bold mb-2 text-gray-700">{t("civil")}</h2>
            <div className="text-gray-700 ">
              {t("civ")}
              <p className="font-normal md:font-bold">
                {t("civ2")}
              </p></div>
            <div className='flex flex-col md:flex-row w-full p-4 justify-between text-blue-400'>
              <h3 className=" font-normal md:font-bold mb-2 ">Breakwaters & Seawalls</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Floating & Fixed Piers </h3>
              <h3 className=" font-normal md:font-bold mb-2  "> Slipways & Dry Docks</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">  Dredging & Reclamation</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Wharf & Jetty Construction</h3>

            </div>
          </div>
          <div className="hidden md:block w-5 h-[300px]  ">
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
          </div>

        </div>

      </Link>

      <Link to={"./marineServis/OffshoreWork"}>

        <div className="h-auto min-h-0 py-8 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white rounded shadow">

          <div className='relative w-full md:w-[500px] h-64 md:h-[400px] '>
            <img src={shore} data-aos="fade-right" className="w-full h-full object-cover rounded border-blue-300 flex-shrink-0" />
            <div className="absolute inset-0 flex  flex-col justify-center ">
              <div className='bg-blue-300 w-20 h-20 m-6  rounded absolute justify-center items-left'>
                <h2 className="text-white  text-xl md:text-xl font-normal md:font-bold p-2">15 years</h2>
              </div>
            </div>
          </div>

          <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-0 md:ml-4 flex flex-col justify-center flex-1 h-auto md:h-[400px] overflow-visible md:overflow-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-4xl font-normal md:font-bold mb-2 text-gray-700">{t("offshore")}</h2>
            <div className="text-gray-700 ">
              {t("off")}
              <p className="font-normal md:font-bold">
                {t("off2")}
              </p></div>
            <div className='flex flex-col md:flex-row w-full p-4 justify-between text-blue-400'>
              <h3 className=" font-normal md:font-bold mb-2 ">Offshore Construction</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Supply & Logistics</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Maintenance & Repairs </h3>
              <h3 className=" font-normal md:font-bold mb-2 ">Crew Transfer & Support</h3>
              <h3 className=" font-normal md:font-bold mb-2 ">  Diving & ROV Services</h3>
            </div>
          </div>
          <div className="hidden md:block w-5 h-[300px]  ">
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
            <div className="w-5 h-5 rounded-full bg-blue-300"></div>
            <div className="w-1 h-10 bg-blue-300 m-2"></div>
          </div>

        </div>

      </Link>

    </div>
  );
};

export default CommercialServices;